import { render, staticRenderFns } from "./matchMappingInfo.vue?vue&type=template&id=64aeeee9&scoped=true&lang=pug&"
import script from "./matchMappingInfo.vue?vue&type=script&lang=js&"
export * from "./matchMappingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aeeee9",
  null
  
)

export default component.exports